import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

productCardStyles.infoGridItem = {
    width: [12, 12, 12, 7, 8],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    max-width: 90%;
                `,
                css`
                    max-width: 90%;
                `,
                null,
                null,
                null,
            ])}
    `,
};
productCardStyles.actionsGridItem = {
    width: [8, 8, 12, 5, 4],
};
productCardStyles.leftColumnGridItem = {
    width: [6, 6, 4, 3, 3],
    css: css`
        padding-right: 20px;
        flex-direction: column;
    `,
};
productCardStyles.rightColumnGridItem = {
    width: [12, 12, 8, 9, 9],
};
